/**
 * Scale a number from one range to another.
 *
 * @param num Original value.
 * @param in_min Original range min boundary.
 * @param in_max Original range max boundary.
 * @param out_min New range max boundary.
 * @param out_max New range max boundary.
 */
export function scale(num: number, in_min: number, in_max: number, out_min: number, out_max: number): number {
  return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}

/**
 * Lerp.
 *
 * @param a
 * @param b
 * @param n
 */
export function lerp(a: number, b: number, n: number): number {
  return (1 - n) * a + n * b;
}
